import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@hooks/useTheme";

export const ComponentHeader = ({ showLicense = true }) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <div className="text-left">
      <div
        className="font-medium truncate"
        title={t("common.component")}
      >
        {t("common.component")}
      </div>

      {showLicense && (
        <div
          className={`text-xs ${colors.textActive} font-normal truncate`}
          title={t("common.component-license")}
        >
          {t("common.component-license")}
        </div>
      )}
    </div>
  );
};